import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "main-side-nav" }
const _hoisted_2 = { class: "sidebar-logo" }
const _hoisted_3 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ProductCloudSidebar = _resolveComponent("ProductCloudSidebar")!
  const _component_BankWatchSidebar = _resolveComponent("BankWatchSidebar")!
  const _component_CdrTestSidebar = _resolveComponent("CdrTestSidebar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: _ctx.logoLink,
        class: "logo-link"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: "/img/brand/pc-dark.png",
            class: "logo-img",
            alt: _ctx.currentProduct
          }, null, 8, _hoisted_3)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    (_ctx.currentProduct === 'productcloud')
      ? (_openBlock(), _createBlock(_component_ProductCloudSidebar, { key: 0 }))
      : (_ctx.currentProduct === 'bankwatch')
        ? (_openBlock(), _createBlock(_component_BankWatchSidebar, { key: 1 }))
        : (_ctx.currentProduct === 'cdrtest')
          ? (_openBlock(), _createBlock(_component_CdrTestSidebar, { key: 2 }))
          : _createCommentVNode("", true)
  ]))
}